<template>
  <wrap-container>
    <h3>¿Cómo pedir el cambio de banco en ANSES?</h3>
    <br />
    <wrap-container class="grid-container grid-container--4-4-4">
      <wrap-container class="col1">
        <div class="card swiper-slide swiper-slide-next">
          <div
            aria-hidden="false"
            class="card__base listlimit__item card__base--white"
            data-dl-component=""
            data-dl-component-name="card_248168734"
            data-dl-component-type="bbva/pwebs/components/par/card"
          >
            <div class="card__container">
              <div class="card__container">
                <div class="grid-container grid-container--6-6 grid-card">
                  <div class="col1">
                    <img
                      src="@/assets/img/desktop_dark.svg"
                      sizes="16vw"
                      class="gift img-menu card__img image--loading image--loaded"
                      alt="Presencial, en una oficina de ANSES, solicitando turno"
                    />
                  </div>
                  <div class="col2">
                    <span class="error">
                      <span>
                        Por internet ingresando a MI ANSES
                        <a
                          aria-label="MI ANSES. Abre en nueva ventana"
                          class="link__base card__link"
                          data-lightbox-shorts="false"
                          href="https://servicioscorp.anses.gob.ar/clavelogon/logon.aspx?system=miansesv2"
                          itemprop="url"
                          onclick="s_objectID='por-internet-ingresando-a-mi-anses'"
                          rel="noopener noreferrer"
                          target="_blank"
                          title="MI ANSES. Abre en nueva ventana"
                        >
                          <br />
                          <a
                            aria-label="MI ANSES. Abre en nueva ventana"
                            class="link__base card__link"
                            data-lightbox-shorts="false"
                            href="https://servicioscorp.anses.gob.ar/clavelogon/logon.aspx?system=miansesv2"
                            itemprop="url"
                            onclick="s_objectID='por-internet-ingresando-a-mi-anses'"
                            rel="noopener noreferrer"
                            target="_blank"
                            title="MI ANSES. Abre en nueva ventana"
                          >
                            <span>
                              <img src="@/assets/img/1x/show.png" alt="" />
                              <span>MI ANSES</span>
                            </span>
                          </a>
                        </a>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </wrap-container>
      <wrap-container class="col2">
        <div class="card swiper-slide swiper-slide-next" style="width: 392px">
          <div
            aria-hidden="false"
            class="card__base listlimit__item card__base--white"
            data-dl-component=""
            data-dl-component-name="card_248168734"
            data-dl-component-type="bbva/pwebs/components/par/card"
          >
            <div class="card__container">
              <div class="grid-container grid-container--6-6 grid-card">
                <div class="col1">
                  <img
                    src="@/assets/img/corporate_building_dark.svg"
                    sizes="16vw"
                    class="gift img-menu card__img image--loading image--loaded"
                    alt="Presencial, en una oficina de ANSES, solicitando turno"
                  />
                </div>
                <div class="col2">
                  <span class="error">
                    <span
                      >Presencial, en una oficina de ANSES, solicitando
                      turno</span
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </wrap-container>
      <wrap-container class="col3">
        <div class="card swiper-slide swiper-slide-next" style="width: 392px">
          <div
            aria-hidden="false"
            class="card__base listlimit__item card__base--white"
            data-dl-component=""
            data-dl-component-name="card_248168734"
            data-dl-component-type="bbva/pwebs/components/par/card"
          >
            <div class="card__container">
              <div class="grid-container grid-container--6-6 grid-card">
                <div class="col1">
                  <img
                    src="@/assets/img/phone_assistance.svg"
                    sizes="16vw"
                    class="gift img-menu card__img image--loading image--loaded"
                    alt="Presencial, en una oficina de ANSES, solicitando turno"
                  />
                </div>
                <div class="col2">
                  <span class="error">
                    <span>Por teléfono llamando al 130</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </wrap-container>
    </wrap-container>
    <wrap-container>
      <a
        class="link-conoce"
        href="https://www.anses.gob.ar/jubilaciones-y-pensiones/cobros-y-haberes/cambio-de-lugar-de-cobro"
        title="Para más información sobre cómo cambiar de Banco, ingresá acá.. Abre en nueva ventana"
        target="_blank"
        aria-label="Para más información sobre cómo cambiar de Banco, ingresá acá.. Abre en nueva ventana"
        itemprop="relatedLink"
      >
        <span class="error">
          <img src="@/assets/img/1x/add.png" alt="" />
          <span> Conocé más sobre cómo cambiar de banco en ANSES </span>
        </span>
      </a>
    </wrap-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
export default {
  name: "Swiper",
  components: { WrapContainer }
};
</script>

<style scoped>
@import "../../style/card/large.css";
@import "../../style/card/small.css";
@import "../../style/critical/large.css";
@import "../../style/critical/small.css";

.grid-card {
  align-items: center;
}

.gift {
  width: 50%;
  left: 25%;
  top: 0%;
  position: relative;
}

.link-conoce {
  padding-top: 30px;
  justify-content: center;
  display: flex;
  padding-bottom: 10px;
}

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > span {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > span {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  line-height: 1.33;
  margin-right: 15px;
}
</style>
